import { render, staticRenderFns } from "./GitView.vue?vue&type=template&id=088b77ac&scoped=true&"
import script from "./GitView.vue?vue&type=script&lang=js&"
export * from "./GitView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088b77ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088b77ac')) {
      api.createRecord('088b77ac', component.options)
    } else {
      api.reload('088b77ac', component.options)
    }
    module.hot.accept("./GitView.vue?vue&type=template&id=088b77ac&scoped=true&", function () {
      api.rerender('088b77ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/git/GitView.vue"
export default component.exports